import React, { useState, useRef, useEffect } from 'react';
import Modal from '../utils/Modal';
import ReactPlayer from 'react-player/lazy'
import LazyLoad from 'react-lazyload';
function HeroHome() {

  const [videoModalOpen, setVideoModalOpen] = useState(false);

  const features = [
  {
    name: 'Computer Architecture',
  },
  {
    name: 'Reactive Synthesis',
  },
  {
    name: 'Compiler Optimizations',
  },
  {
    name: 'Language Processors and Execution Environments',
  },
  {
    name: 'Architectures for Machine Learning',
  },
  {
    name: 'Hardware Verification and Validation',
  },
  {
    name: 'Program Testing and Verification',
  },
  {
    name: 'Computer Hardware Fundamentals',
  },
  {
    name: 'Compilers for Machine Learning',
  },
]

const prereqs = [
  {
    name: 'Computer Organization',
  },
  {
    name: 'Computer Architecture',
  },
  {
    name: 'Mathematical Logic',
  },
  {
    name: 'Compiler Design',
  },
]

  const videoRef = useRef(null);
  useEffect(() => {
    if(videoRef){
      videoRef.current.play();
    }
  }, []);

  return (
      <header className="relative flex items-center justify-center mb-12 overflow-hidden" id="top">
          <video
              ref={videoRef}
              preload="none"
              loop
              muted
              playsInline
              className="opacity-5 absolute z-0 w-auto min-w-full
               min-h-full max-w-none"
          >
            <source
                src={require('../videos/code_1.mp4').default}
                type="video/mp4"
            />
          </video>
    <section className="relative relative z-10 p-5">

      <div className="max-w-6xl mx-auto px-4 sm:px-6">

        {/* Hero content */}
        <div className="pt-32 pb-12 md:pt-40 md:pb-20">
          {/* Section header */}
          <div className="text-center pb-12 md:pb-16">
            <h1 className="text-4xl font-extrabold leading-tighter tracking-tighter" data-aos="zoom-y-out">ACM Winter School</h1>
            <h2 className="bg-clip-text text-3xl font-extrabold font-mono text-transparent bg-gradient-to-r from-blue-900 to-blue-500" data-aos="zoom-y-out">Design, Implementation and Verification of Computer Systems</h2>
            <h2 className="bg-clip-text text-3xl font-extrabold text-transparent bg-gray-600" data-aos="zoom-y-out">3rd-January - 14th January, 2022</h2>
            <div className="max-w-3xl mx-auto">
              <br />
              <br />
              <p className="text-xl text-gray-600 mb-8" data-aos="zoom-y-out" data-aos-delay="150">The school will focus on the design, implementation and verification of two of the primary components of computer systems, computer architecture and compilation system. Starting with fundamentals, the school will expose the participants to designing subsystems, verifying/validating them and also expose them to newer innovations to support modern applications that use machine learning.</p>
              <br />
        {/* ring-1 ring-offset-1 ring-offset-yellow-100 ring-yellow-200  */}
        <h5 className="text-xl md:text-2xl font-extrabold leading-tighter tracking-tighter mb-4" data-aos="zoom-y-out">Topics Covered</h5>
        <div className="mt-10" data-aos="zoom-y-out" data-aos-delay="150">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3">
            {features.map((feature) => (
                <div key={feature.name} className="card cursor-pointer rounded-lg transition-all duration-200">
                  <div className="m-1">
                    <span className="px-1 py-1 inline justify-center rounded-lg shadow-xl text-white bg-gradient-to-r from-green-500 to-blue-400
                    font-mono font-bold hover:bg-gradient-to-r hover:from-blue-500 hover:to-teal-400 text-sm flex cursor-pointer">{feature.name}
                  {/* <span className="text-sm text-teal-800 font-mono bg-teal-100 inline rounded-full px-2 align-top float-right animate-pulse">Tag</span> */}
                  </span>
                  </div>
                </div>
            ))}
          </div>
        </div>
        <br />
         <h5 className="text-xl md:text-2xl font-extrabold leading-tighter tracking-tighter mb-4" data-aos="zoom-y-out">Prerequisites Expected</h5>
        <div className="mt-10" data-aos="zoom-y-out" data-aos-delay="150">
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2">
            {prereqs.map((feature) => (
                <div key={feature.name} className="card cursor-pointer rounded-lg">
                  <div className="m-1">
                    <span className="px-2 py-1 inline text-center justify-center rounded-lg text-white shadow-xl
                    bg-gradient-to-r from-blue-500 to-teal-400 hover:bg-gradient-to-r hover:from-teal-500 hover:to-blue-400 font-mono
                    font-bold text-sm flex align-center cursor-pointer">{feature.name}
                  {/* <span className="text-sm text-teal-800 font-mono bg-teal-100 inline rounded-full px-2 align-top float-right animate-pulse">Tag</span> */}
                  </span>
                  </div>
                </div>
            ))}
          </div>
        </div>
              {/*<br />*/}
              {/*<br />*/}
              {/*<h5 className="text-xl md:text-2xl font-extrabold leading-tighter tracking-tighter mb-4"*/}
              {/*    data-aos="zoom-y-out">Tools & Frameworks</h5>*/}
              {/*<h5 className="text-xl text-gray-800">*/}
              {/*  Although not exhaustive, we will be using these tools for demonstrations during the hands-on sessions. You may be asked to install and*/}
              {/*  run these tools for completing the related assignments.*/}
              {/*</h5>*/}
              {/*<div className="mt-10" data-aos="zoom-y-out" data-aos-delay="150">*/}
              {/*  <div className="grid grid-cols-4 sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-4 gap-2">*/}
              {/*    {tools.map((feature) => (*/}
              {/*        <div key={feature.name} className="card cursor-pointer rounded-lg shadow-sm">*/}
              {/*          <div className="m-1 flex flex-row text-left w-max">*/}
              {/*            <img className="mx-auto w-8 h-8" src={require(`../images/${feature.image}`).default} />*/}
              {/*      <span className="px-2 py-1 inline text-center rounded-lg text-gray-800*/}
              {/*      font-mono font-bold text-sm flex align-center cursor-pointer">{feature.name}*/}
              {/*        /!* <span className="text-sm text-teal-800 font-mono bg-teal-100 inline rounded-full px-2 align-top float-right animate-pulse">Tag</span> *!/*/}
              {/*      </span>*/}
              {/*          </div>*/}
              {/*        </div>*/}
              {/*    ))}*/}
              {/*  </div>*/}
              {/*</div>*/}

        <br />
        <br />
              <div className="max-w-xs mx-auto sm:max-w-none sm:flex sm:justify-center" data-aos="zoom-y-out" data-aos-delay="300">
                <div className="flex flex-row justify-center px-2">
                  <a className="btn text-white rounded-full shadow-xl px-4 transition duration-700 ease-in-out bg-blue-600 hover:bg-white
                  hover:text-black w-full mb-4 sm:w-auto sm:mb-0" href="https://iitk-ac-in.zoom.us/j/99543482573?pwd=Ni9kTnp4cVQxMEEwYjI3RUl1VTdldz09">
                    <LazyLoad height="12">
                      <img className="mx-auto px-1" src={require('../images/zoom.png').default} width="30" height="12" alt="Zoom"/>
                    </LazyLoad>Join Zoom</a>
                </div>
                <div className="flex flex-row justify-center px-2">
                  <a className="btn text-white bg-gray-900 rounded-full shadow-xl px-4 transition duration-700 ease-in-out shadow-xl hover:bg-white hover:text-black w-full mb-4 sm:w-auto sm:mb-0"
                     href="https://india.acm.org/education/computer-systems-design-winter-2022">
                    <LazyLoad height="12">
                      <img className="mx-auto px-1" src={require('../images/sheet.png').default} width="30" height="12" alt="Zoom"/>
                    </LazyLoad>
                    More Resources</a>
                </div>
                <div className="flex flex-row justify-center px-2">
                  <a className="btn text-black bg-purple-300 rounded-full shadow-xl px-4 transition duration-700 ease-in-out shadow-xl hover:bg-purple-100 hover:text-black w-full mb-4 sm:w-auto sm:mb-0"
                     href="https://discord.gg/25JAKcXfzx">
                    <LazyLoad height="12">
                      <img className="mx-auto px-1 rounded-full" src={require('../images/discord.png').default} width="30" height="12" alt="Zoom"/>
                    </LazyLoad>
                    Join Discord</a>
                </div>
              </div>
            </div>
          </div>
          <div className="absolute left-0 right-0 bottom-0 m-auto w-px p-px h-20 bg-gray-300 transform translate-y-1/2"></div>
          {/* Hero image */}
          <div>
            <div className="relative flex justify-center mb-8" data-aos="zoom-y-out" data-aos-delay="450">
              <div className="flex flex-col justify-center">
                <LazyLoad height={400}>
                  <img className="mx-auto" src={require('../images/conference.jpg').default} width="640" height="400" alt="Hero" />
                </LazyLoad>
              </div>
              <button className="absolute top-full flex items-center transform -translate-y-1/2 bg-white rounded-full font-medium group p-4 shadow-lg" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setVideoModalOpen(true); }} aria-controls="modal">
                <svg className="w-6 h-6 fill-current text-gray-400 group-hover:text-blue-600 flex-shrink-0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0 2C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12z" />
                  <path d="M10 17l6-5-6-5z" />
                </svg>
                <span className="ml-3" aria-required="true" >Watch Recording</span>
                <span id="tip1" className="tooltip hidden" role="tooltip">Not Active Yet</span>
              </button>
            </div>

            {/* Modal */}
            {/*<Modal id="modal" ariaLabel="modal-headline" show={videoModalOpen} handleClose={(e) => {setVideoModalOpen(false);}}>*/}
            {/*  <div className="relative pb-9/16">*/}
            {/*      <ReactPlayer className="absolute w-full h-full" url="https://www.youtube.com/watch?v=xzxI-7mWVCI" playing={videoModalOpen} width="100%" height="100%"/>*/}
            {/*  </div>*/}
            {/*</Modal>*/}
          </div>
        </div>
      </div>
    </section>
      </header>
  );
}

export default HeroHome;